<template>
	<app-layout>
		<div class="page-blog">
      <div class="page-blog-container mx-auto">
        <div class="scrollable-container">
          <app-categories-scrollable>
            <button class="category-button px-8"
              :class="{ 'category-button--active' : selectedCategory.slug === 'all' }"
              @click="selectedCategory = { name: 'all', slug: 'all' }">
              {{$t("blog.all_destinations")}}
            </button>
            <button class="category-button px-8"
              :class="{ 'category-button--active' : selectedCategory === category }"
              v-for="category in categories" :key="category.slug"
              @click="selectedCategory = category">
              {{ category.name }}
            </button>
          </app-categories-scrollable>
        </div>
        <div class="space pt-0">
          <div class="grid" :class="{ 'few-posts' : [1, 2].includes(postsShown.length) }">
            <app-card-blog v-for="post in postsShown"
              :key="post.id"
              :title="post.title"
              :image="post.image"
              :alt_image="post.alt_image"
              :date="post.date_published"
              :description="post.description"
              :link="post.link"
              :blog-index-page="true">
            </app-card-blog>
          </div>
        </div>
      </div>
		</div>
	</app-layout>
</template>

<script lang="ts">
import router from "../../router";
import handleAppBarItems from "../../utils/handleAppBarItems";

export default {
  props: ['posts'],
	data: () => ({
    selectedCategory: { name: 'all', slug: 'all' }
  }),
  computed: {
    categories() {
      const categories = this.posts.map(p => {
        const category = p.category;
        return category ? { name: category.name, slug: category.slug } : null;
      }).filter(Boolean);

      return [...new Set(categories)];
    },
    postsShown() {
      if (this.selectedCategory.slug === 'all') return this.posts;

      return this.posts.filter(p => p.category && p.category.name === this.selectedCategory.name);
    }
  },
  created() {
    const categorySlug = this.$route.query.destino;
    this.updateHeader();
    if (categorySlug) {
      const selectedCategory = this.categories.find(c => c.slug === categorySlug);
      if (selectedCategory) {
        this.selectedCategory = selectedCategory;
        this.$nextTick(() => {
          const { left, width } = this.$el.querySelector('.category-button--active').getBoundingClientRect();
          this.$el.querySelector('.hs.no-scrollbar').scrollLeft = left - ((window.innerWidth - width) / 2);
        })
      }
    }
  },
  methods: {
    updateHeader() {
      this.$eventHub.$emit(
        "update-header",
        handleAppBarItems.call(this, router.currentRoute)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.page-blog {
  padding-bottom: 3rem;
  @media (min-width: 1024px) {
    padding-bottom: 4rem;
  }
  @media (min-width: 1280px) {
    padding-bottom: 6rem;
  }
}
.category-button {
  border-radius: 25px;
  color: #001d38;
  border: solid 1px #b7b7b7;
  white-space: nowrap;

  &--active {
    background-color: #001d38;
    color: white;
  }
}
.card--blog {
  max-width: none !important;
}
.grid {
  grid-template-columns: 1fr;
  grid-gap: 30px;
  @media (min-width: 640px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    grid-gap: 40px;
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }
  &.few-posts {
    grid-template-columns: repeat(auto-fit, minmax(280px, 497px));
    justify-content: center;
  }
}
.scrollable {
  margin: 2rem 0;
  @media (min-width: 768px) {
    margin: 3rem 0;
  }
  @media (min-width: 1024px) {
    margin: 5rem 0 3.5rem -10px;
  }
}
.space {
  max-width: 90vw;
  margin: auto;
}
.scrollable-container {
  @media (min-width: 1024px) {
    max-width: 90vw;
    margin: auto;
  }
}
</style>
